<!-- BOM匹配详情弹框 -->
<template>
  <el-dialog 
    width="1000px" 
    title="匹配详情" 
    top="100px" 
    append-to-body
    custom-class="bom-item-dialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :visible="isShow" 
    @close="close"
  >
    <div v-loading="loading" class="bom-item-dialog__content">
      <div class="bom-item-dialog__content__top">
        <p>文件名：{{ bomData.bomName || '--' }}</p>
        <p>套数：{{ bomData.number || '--' }}</p>
      </div>
      <el-table
        border
        max-height="450"
        style="width: 100%"
        :data="bomData.bomItemVoList || []"
      >
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="goodsName" label="型号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="goodsDesc" label="规格参数" show-overflow-tooltip></el-table-column>
        <el-table-column prop="encap" label="封装" show-overflow-tooltip></el-table-column>
        <el-table-column prop="location" label="位号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="dosage" label="单机用量" width="80" show-overflow-tooltip></el-table-column>
        <el-table-column prop="number" label="总用量" width="70" show-overflow-tooltip></el-table-column>
        <el-table-column prop="totalNumber" label="购买量" width="70" show-overflow-tooltip></el-table-column>
        <el-table-column prop="status" label="选型结果" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="totalPrice" label="价格" width="100" show-overflow-tooltip></el-table-column>
      </el-table>
      <div class="bom-item-dialog__content__total">
        合计：{{ bomData.totalPrice || '--' }}
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { checkBomMatchItem } from '@@/api/pcba'

export default {
  data() {
    return {
      isShow: false,
      loading: false,
      bomData: {}
    }
  },
  methods: {
    open(bomId) {
      this.getList(bomId)
      this.isShow = true
    },
    close() {
      this.isShow = false
    },
    getList(oneStopBomId) {
      this.loading = true
      checkBomMatchItem({ oneStopBomId })
        .then(res => {
          if(!res) return
          const { retCode, result } = res
          if (retCode === 0) {
            this.bomData = result
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  }
}
</script>

<style lang="scss">
.bom-item-dialog {
  $barderColor: #000;
  .el-dialog__header .el-dialog__title {
    font-weight: 700;
    color: $--color-text-primary;
  }
  .el-dialog__body {
    padding: 0 20px 40px;
  }
  .el-dialog__footer {
    padding-bottom: 30px;
  }

  .bom-item-dialog__content {
    .el-table {
      border-color: $barderColor;
      border-right: 1px solid $barderColor;
      th.el-table__cell {
        font-weight: 700;
        color: #000;
        background-color: #ddebf7;
        border-color: $barderColor;
      }

      td.el-table__cell {
        padding: 0;
        color: #000;
        border-color: $barderColor;
      }
    }

    .bom-item-dialog__content__top {
      display: flex;
      align-items: center;
      padding: 0 10px;
      height: 40px;
      font-weight: 700;
      color: #000;
      background-color: #e2efda;
      border: 1px solid $barderColor;
      border-bottom: 0;
      >p:first-child {
        width: 70%;
      }
      >p:last-child {
        flex: 1;
      }
    }
    
    .bom-item-dialog__content__total {
      padding-right: 20px;
      height: 40px;
      line-height: 40px;
      text-align: right;
      border: 1px solid $barderColor;
    }
  }
}
</style>